import { autoWebViewJs, isRealInAndroid } from '@droid/android';

import { androidController, autoJsStoreUtils } from '@droid/android';
import { Dispatcher, Log, browserHistoryUtils, listenDocumentActive, storeUtils, tabActivity } from '@fanfanlo';
import { user } from '../../user/User';
import { initAndroid } from './initAndroid';

// @autobind
const fileLog = new Log(false, 'AppController_f')
fileLog.pause = true;
fileLog.childrenPaused = true;

class AppController extends Dispatcher {
  constructor() {
    super();
  }

  /**
   * 基础功能初始化（所有应用都需要）
   * 包括：Android 集成、浏览器历史、标签页活动、用户初始化等
   */
  async initCore() {
    fileLog.log('[AppController.initCore] 开始初始化基础功能')

    const storeUtilsConf = {
      read: autoJsStoreUtils.read,
      write: autoJsStoreUtils.write,
      ns: {},
    };

    listenDocumentActive();
    browserHistoryUtils.initBrowserHistoryListener();
    await initAndroid();
    await androidController.init();

    setTimeout(() => {
      fileLog.log('has autowebviewjs', autoWebViewJs)
      autoWebViewJs?.onDocumentReady();
      fileLog.log('autowebviewjs on document ready')
    }, 1000 * 5);

    if (autoWebViewJs) {
      Object.defineProperty(window, 'autoWebViewJs', {
        value: autoWebViewJs,
        writable: false,
        configurable: false,
        enumerable: false, // 可选：不让它出现在 for...in 中
      });
    }

    (window as any).storeUtilsConf = storeUtilsConf;
    tabActivity.init();

    if (isRealInAndroid) {
      storeUtils.setStoresProxy({
        read: autoJsStoreUtils.read,
        write: autoJsStoreUtils.write,
        ns: {},
      });
    }

    // 不阻塞的用户初始化
    initDependOnRemoteCore();

    fileLog.log('[AppController.initCore] 基础功能初始化完成')
  }

  /**
   * 完整初始化（向后兼容）
   * 包括基础功能和项目管理功能
   */
  async init() {
    fileLog.log('[AppController.init] 开始完整初始化AppController')
    await this.initCore();

    // 动态导入项目管理扩展
    const { initProjectSystem } = await import('./AppControllerProjectExt');
    await initProjectSystem();

    fileLog.log('[AppController.init] 完整初始化完成')
  }
}

/**
 * 基础功能的远程依赖初始化
 */
async function initDependOnRemoteCore() {
  await user.init();
}

export const appController = new AppController();
